function getAttachmentName (fullName) {
  return (fullName[8] === '-' && fullName.indexOf('.') === 36)
    ? fullName.slice(37)
    : fullName
}
exports.getAttachmentName = getAttachmentName
